import { render, staticRenderFns } from "./Yulan.vue?vue&type=template&id=883a564a&scoped=true&"
import script from "./Yulan.vue?vue&type=script&lang=js&"
export * from "./Yulan.vue?vue&type=script&lang=js&"
import style0 from "./Yulan.vue?vue&type=style&index=0&id=883a564a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883a564a",
  null
  
)

export default component.exports